import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA }   from '@angular/material/dialog';

import { Wordcloud }      from '@shared/ui/wordcloud/wordcloud';
import { MOCK_WORDCLOUD } from '@modals/wordcloud-modal/wordcloud.mock';


@Component({
  selector:    'red-app-wordcloud-modal',
  templateUrl: './wordcloud-modal.component.html',
  styleUrls:   [ './wordcloud-modal.component.scss' ]
})
export class WordcloudModalComponent implements OnInit {
  public display: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public wordcloud: Wordcloud,
  ) {

  }

  ngOnInit(): void {
    setTimeout(() => this.display = true, 500);
  }
}
